export default __webpack_public_path__ + "static/media/947.d6a2aacc.png";